function prediction_mountflood(){
    // global參數
    let mountFloodList = {
        html: "",
        data: ajax_call(publicPath + "/napi/simulate/mountflood/mount")
    }
    mountFloodList.data.forEach(el => {
        mountFloodList.html += `<option value="${el.predict_time}">${el.predict_time.replace("T"," ")}</option>`
    })
    // 
    $("#map_clear").click()
	$("#prediction_mountflood").html(`
        <div class="pr-2" style="height: calc( 100vh - 115px );">  
            <h5 class="font-weight-bold mb-0"><i class="fas fa-info-circle mr-2"></i>
                山區閃洪預測&平地淹水預測模組說明</h5>
            <h6 class="text-justify mt-1">
                山區閃洪預測&平地淹水預測模組為洪災淹水預警結合氣象降雨預報模式，將網格化雨量轉換成水動力模式輸入格式，
                經過淹水模式計算後，提供未來24小時可能積淹水之空間分布、積淹水範圍及積淹水深度，以供河川水位及溢淹研判情資。
                (本資料為kmz檔，每日更新時間為04:40、10:40、16:40、22:40)
            </h6>
            <div class="input-group mb-2"> 
                <div class="input-group-prepend"> 
                    <span class="input-group-text">預報區域選擇</span> 
                </div> 
                <select class="form-control" id="mountflood-prediction-area-selector">
                    <option value="山區閃洪預測">山區閃洪預測</option>
                    <option value="平地淹水預測">平地淹水預測</option>
                </select>
            </div>
            <div class="input-group mb-2"> 
                <div class="input-group-prepend"> 
                    <span class="input-group-text">預報時間選擇</span> 
                </div> 
                <select class="form-control" id="mountflood-prediction-time-selector">
                    ${mountFloodList.html}
                </select>
            </div>
            <button type="button" class="btn btn-success btn-sm btn-block mt-2" id="mountflood-prediction-report-trig">查詢</button>
            <hr>
            <div id="mountflood-prediction-content"></div>
        </div>`
    )
    
    $('#mountflood-prediction-area-selector').change(() => {
        mountFloodList.html = ""
        if ($('#mountflood-prediction-area-selector').val() == "山區閃洪預測") {
            mountFloodList.data = ajax_call(publicPath + "/napi/simulate/mountflood/mount")
        } else if ($('#mountflood-prediction-area-selector').val() == "平地淹水預測") {
            mountFloodList.data = ajax_call(publicPath + "/napi/simulate/mountflood/plain")
        }
        mountFloodList.data.forEach(el => {
            mountFloodList.html += `<option value="${el.predict_time}">${el.predict_time.replace("T"," ")}</option>`
        })
        $("#mountflood-prediction-time-selector").html(mountFloodList.html)
    })

    $("#mountflood-prediction-report-trig").click(function(){
        $('#mountflood-prediction-content').html(`
            <div class="px-3 py-2">
                <h5 class="font-weight-bold">目前檢視之預報區域：${$('#mountflood-prediction-area-selector').val()}</h5>
                <h5 class="font-weight-bold">目前檢視之預報時間：${$('#mountflood-prediction-time-selector').val().replace("T"," ")}</h5>
            <div>
        `)
        if (overlay_dataset['山區閃洪&平地淹水預測圖層']) {
            map.removeLayer(overlay_dataset['山區閃洪&平地淹水預測圖層'])
        }
        let target = mountFloodList.data.find(el => el.predict_time == $('#mountflood-prediction-time-selector').val())
        let imageBounds = [[target.south, target.west], [target.north, target.east]]
        let targetLayer = L.imageOverlay("data:image/png;base64, " + target.predict_image, imageBounds)
        if ($('#mountflood-prediction-area-selector').val() == "山區閃洪預測") {
            $("#legend_div_container").html(
                '<div class="legend_text">山區閃洪<br><img src="legend/mountflood.png" width="100%"></div>'
            )
            map.setView([24.86214187060511, 121.55117833068326], 15)
            $("#base_layer .leaflet-layerstree-children").find("input").eq(5).click();
        } else if ($('#mountflood-prediction-area-selector').val() == "平地淹水預測") {
            $("#legend_div_container").html(
                '<div class="legend_text">平地淹水<br><img src="legend/plainflood.png" width="100%"></div>'
            )
            map.setView([25.040592104145098, 121.44794006136652], 13)
            $("#base_layer .leaflet-layerstree-children").find("input").eq(5).click();
        }
        overlay_dataset['山區閃洪&平地淹水預測圖層'] = targetLayer
        map.addLayer(overlay_dataset['山區閃洪&平地淹水預測圖層'])
    })   
}
